import { Button } from '@/components/ui/button';

/** The "older" control of a keyset-paged list, which has no page count and no jumping. */
export function KeysetMore({
  hasMore,
  isFetching,
  onMore,
}: {
  hasMore: boolean;
  isFetching: boolean;
  onMore: () => void;
}) {
  if (!hasMore) return null;
  return (
    <div className="flex justify-center pt-2">
      <Button variant="outline" size="sm" disabled={isFetching} onClick={onMore}>
        {isFetching ? 'Loading…' : 'Older'}
      </Button>
    </div>
  );
}
